<ng-container ntapWindowRegistry>

<p-toolbar class="flex justify-content-end">
  <p-button class="float-right" (onClick)="navigateToTablicni()" icon="pi pi-fw pi-list"></p-button>
</p-toolbar>

<ng-container *ngIf="(view$ | async) as view; else loadingView">
  <ng-container *ngIf="(tableMeta$ | async) as tableMeta; else loadingView">
    <ng-container *ngIf="(tableData$ | async) as tableData; else loadingView"> 
      <ng-container *ngIf="((loadingState$ | async) === false) ; else loadingView">
        
      <div *ngIf="currentView === 'prostorije'">
        <ng-container *ngIf="tableData.items.length === 0 else ima">
          <div class="selected-item-info" (click)="vrati()">
            <i class="pi pi-arrow-left"></i> Nema prostorija. Kliknite za povratak na objekt.
          </div>
        </ng-container>
        <ng-template #ima>
          <div class="selected-item-info" (click)="loadBuildings()">
            <i class="pi pi-arrow-left"></i>
            <div>{{ $any(tableData.items)[0]['earhiv~spremiste_objekt~identifikator'] }}</div>
          </div>
        </ng-template>
      </div>

      <div *ngIf="currentView === 'jedinice'">
        <ng-container *ngIf="tableData.items.length === 0 else ima">
          <div class="selected-item-info" (click)="vrati()">
            <i class="pi pi-arrow-left"></i> Nema spremišnih jedinica. Kliknite za povratak na prostoriju.
          </div>
        </ng-container>
        <ng-template #ima>
          <div class="selected-item-info" (click)="vratiNaProstorije($any(tableData.items)[0])">
            <i class="pi pi-arrow-left"></i>
            <div>{{ $any(tableData.items)[0]['earhiv~spremiste_prostorija~identifikator'] }}</div>
          </div>
        </ng-template>
      </div>
      <div *ngIf="currentView === 'lokacije'">
        <ng-container *ngIf="tableData.items.length === 0 else ima">
          <div class="selected-item-info" (click)="vrati()">
            <i class="pi pi-arrow-left"></i> Nema lokacija. Kliknite za povratak na objekt.
          </div>
        </ng-container>
        <ng-template #ima>
          <div class="selected-item-info" (click)="vratiNaJedinicu($any(tableData.items)[0])">
            <i class="pi pi-arrow-left"></i>
            <div>{{ $any(tableData.items)[0]['earhiv~spremiste_spremisna_jedinica~identifikator'] }}</div>
          </div>
        </ng-template>
      </div>


      <div class="container">

        <ng-template ngFor let-item let-rowIndex="index" [ngForOf]="tableData.items">
          <!-- {{test(vie.)}} -->

          <ng-container ntapListItemProvider #lid="ntapListItemProvider" [listIndex]="rowIndex" [item]="item"
            *ngIf="tableData.tableItems[rowIndex] as tableItem">

            <div *ngIf="currentView === 'buildings'">
              <div
                (click)="handleClick('prostorije', 'spremiste_prostorije', tableItem, 'earhiv~spremiste_objekt', 'earhiv~spremiste_prostorija')"
                class="item">
                <div class="display-text">
                  <div>{{ $any(tableItem)['earhiv~spremiste_objekt~identifikator'] }}</div>
                  <div>{{ $any(tableItem)['earhiv~spremiste_objekt~naziv'] }}</div>
                  <div>{{ $any(tableItem)['earhiv~spremiste_objekt~adresa'] }}</div>
                </div>
                <div class="actions-button">
                  <ntap-dynamic [compId]="DEFAULT_ACTION_BAR_COMP_ID"></ntap-dynamic>
                </div>
              </div>
            </div>

            <div *ngIf="currentView === 'prostorije'">
              <div
                (click)="handleClick('jedinice', 'spremiste_spremisne-jedinice', tableItem, 'earhiv~spremiste_prostorija')"
                class="item">
                <div class="display-text">
                  <div>{{ $any(tableItem)['earhiv~spremiste_prostorija~identifikator'] }}</div>
                  <div>{{ $any(tableItem)['earhiv~spremiste_prostorija~naziv'] }}</div>
                </div>
                <div class="actions-button">
                  <ntap-dynamic [compId]="DEFAULT_ACTION_BAR_COMP_ID"></ntap-dynamic>
                </div>
              </div>
            </div>

            <div *ngIf="currentView === 'jedinice'">
              <div
                (click)="handleClick('lokacije', 'spremiste_lokacije', tableItem, 'earhiv~spremiste_spremisna_jedinica')"
                class="item">
                <div class="display-text">
                  <div>{{ $any(tableItem)['earhiv~spremiste_spremisna_jedinica~identifikator'] }}</div>
                  <div>{{ $any(tableItem)['earhiv~spremiste_spremisna_jedinica~naziv'] }}</div>
                  <div>Kapacitet: {{ $any(tableItem)['earhiv~spremiste_spremisna_jedinica~kapacitet'] }}</div>
                </div>
                <div class="actions-button">
                  <ntap-dynamic [compId]="DEFAULT_ACTION_BAR_COMP_ID"></ntap-dynamic>
                </div>
              </div>

            </div>

            <div *ngIf="currentView === 'lokacije'">
              <div
              [ngClass]="$any(tableItem)['earhiv~spremiste_lokacija~status_lokacije'] === 'Slobodno' ? 'item-green' : 'item-red'"
                class="item">
                <div class="display-text">
                  <div>{{ $any(tableItem)['earhiv~spremiste_lokacija~identifikator'] }}</div>
                </div>
                <div class="status-indicator" *ngIf="$any(tableItem)['earhiv~spremiste_lokacija~status_lokacije'] !== 'A'">
                  {{test(item)}}
                  {{$any(tableItem)['earhiv~spremiste_lokacija~status_lokacije']}}
                </div>
                <div class="actions-button">
                  <ntap-dynamic [compId]="DEFAULT_ACTION_BAR_COMP_ID"></ntap-dynamic>
                </div>
              </div>

            </div>

          </ng-container>
        </ng-template>
      </div>


      <p-paginator class="custom-paginator" (onPageChange)="tableMeta.pagingSetup.pageHandler($event, tableData)"
        [first]="tableData.firstIndex" [rows]="tableData.rows" [totalRecords]="tableData.totalRecords"
        [rowsPerPageOptions]="[10,15, 20, 30, 50, 100]" [showJumpToPageInput]="true">
      </p-paginator>
    </ng-container>
  </ng-container>
</ng-container>
</ng-container>

<ng-template #loadingView>
  <p-progressSpinner></p-progressSpinner>
</ng-template>


<ntap-view-window target="detail" [contentTemplate]="viewWindowContent">
  <ng-template #viewWindowContent let-defaultTemplate>
      <ntap-prime-popupview appendTo="body">
          <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
      </ntap-prime-popupview>
  </ng-template>
</ntap-view-window>
</ng-container>
